import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ChangeTeam from './forms/change-team'
import EditPlayer from './forms/edit_player'
import { ajaxGet, ajaxDelete } from '../../ajax'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

const Players = ({league, teams}) => {
  const [showMenu, setShowMenu] = useState(null)
  const [showTeam, setShowTeam] = useState(null)
  const [showForm, setShowForm] = useState(null)
  const [players, setPlayers] = useState([])
  const [loading, setLoading] = useState(false)
  const menuRef = useRef()
  const skillLevels = {0: 'Beginner', 1: 'Intermediate', 2: 'Advanced', 3: 'Expert'}

  useEffect(() => {
    loadPlayers()
  }, [])

  const loadPlayers = () => {
    ajaxGet(`/admins/leagues/${league.id}/members.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      setPlayers(json.players)
      setLoading(false)
    })
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setShowMenu(null)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [menuRef])

  const imageUrl = (player) => {
    if (!player.image_url) return '/images/ic_user@2x.png'

    return player.image_url + '?' + Math.random()
  }

  const updatePlayer = (player) => {
    const index = players.findIndex(p => p.id == player.id)
    setPlayers([
      ...players.slice(0, index),
      player,
      ...players.slice(index + 1, players.length)
    ])
  }

  const removePlayer = (id) => {
    const playerIndex = players.findIndex(player => { return player.id == id })
    setPlayers([
      ...players.slice(0, playerIndex), 
      ...players.slice(playerIndex + 1, players.length)
    ])
  }

  const onRemovePlayer = (id) => {
    if (window.confirm('Are you sure you want to remove this player?')) {
      setLoading(true)
      ajaxDelete(`/admins/leagues/${league.id}/members/${id}.json`)
      .then(response => { if (response.ok) return response.json() })
      .then((json) => {
        setLoading(false)
        removePlayer(id)
      })
    }
  }

  const onUpdatePlayer = (player) => {
    setShowTeam(null)
    setShowForm(null)
    updatePlayer(player)
  }

  const formattedPhone = player => {
    return player.country_code && player.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(player.phone) : formatPhoneNumber(player.phone)
  }

  const playersList = () => {
    return players.map((player, i) => {
      const skillLevel = skillLevels[player.skill_level]

      return <tr key={i}>
        <td>
          <div className='player-title'><img src={imageUrl(player)} /><span>{player.name}</span></div>
        </td>
        <td><div className='player-phone'>{formattedPhone(player)}</div></td>
        <td>{player.email}</td>
        <td>{player.prefer_position && <div className='player-position'>{player.prefer_position}</div>}</td>
        <td>{player.captain && <div className='player-captain' />}</td>
        <td>{skillLevel && <div className={`player-skill-level ${skillLevel.toLowerCase()}`}>{skillLevel}</div>}</td>
        <td>{player.team_name}</td>
        <td>
          <img className='player-actions' src='/images/leagues/more.svg' onClick={() => setShowMenu(player.id)} />
          { showMenu == player.id && 
            <div className='player-actions__menu' ref={menuRef}>
              <div className='menu-item' onClick={() => setShowForm(player)}>Edit player</div>
              <div className='menu-item' onClick={() => setShowTeam(player)}>Add/change player team</div>
              <div className='menu-item' onClick={() => onRemovePlayer(player.id)}>Remove player</div>
            </div>
          }
        </td>
      </tr>
    })
  }

  return <div className='league-players-wrapper'>
    <div id='league-players'>
      { loading && <div className='animated-spinner'></div> }
      <div className={'players-table-wrap' + (loading ? ' isLoading' : '')}>
        { loading && <div className='animated-spinner'></div> }
        <table className='players-table'>
          <thead>
            <tr>
              <th>PLAYER</th>
              <th>PHONE</th>
              <th>EMAIL</th>
              <th>POSITION</th>
              <th>CAPTAIN</th>
              <th>SKILL LEVEL</th>
              <th>TEAM</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {playersList()}
          </tbody>
        </table>
      </div>
    </div>
    { showTeam && 
      <ChangeTeam
        league={league}
        player={showTeam}
        teams={teams}
        onClose={() => setShowTeam(null)}
        onUpdate={onUpdatePlayer}
      />
    }
    { showForm && 
      <EditPlayer
        league={league}
        player={showForm}
        onClose={() => setShowForm(null)}
        onUpdate={onUpdatePlayer}
      />
    }
  </div>
}

Players.propTypes = {
  league: PropTypes.object.isRequired,
  teams: PropTypes.array.isRequired,
}

export default Players
